import { useEffect, useState } from "react";
import { Modal } from "@/components/ui/Modal";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";

interface ModalNovoGrupoProps {
  open: boolean;
  onClose: () => void;
  onSave: (nome: string) => Promise<void>;
}

export function ModalNovoGrupo({ open, onClose, onSave }: ModalNovoGrupoProps) {
  const [nome, setNome] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setNome("");
    setError("");
  }, [open]);

  const handleSubmit = async () => {
    if (!nome.trim()) {
      setError("Informe o nome do grupo.");
      return;
    }
    setSaving(true);
    try {
      await onSave(nome.trim());
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Novo grupo de tarefas"
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} disabled={saving}>
            Cancelar
          </Button>
          <Button loading={saving} onClick={handleSubmit}>
            Criar grupo
          </Button>
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-sm text-slate-500">
          Crie grupos para organizar tarefas por obra, equipe, escritório ou qualquer contexto
          que facilite o seu dia a dia.
        </p>
        <Input
          label="Nome do grupo"
          value={nome}
          onChange={(e) => {
            setNome(e.target.value);
            setError("");
          }}
          error={error}
          placeholder="Ex.: Obra Riviera, Equipe SP, Escritório Centro"
          autoFocus
        />
      </div>
    </Modal>
  );
}
